
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStacked50 as ObiTwowayStacked50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-50.js';
 
 
 

 
 export const ObiTwowayStacked50 = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-50',
   elementClass: ObiTwowayStacked50Element,
   events: {
     
   }
  });
 
 